import React from 'react';
import { useTheme } from 'styled-components';
import { Paragraph } from '../../../atoms/Typography';
export const ZERO_WIDTH_SPACE = '\u200B';
export const Message = ({ message = undefined, status = undefined, styling: stylingProp = undefined, id, dataTestId, }) => {
    const { colorContext, colors } = useTheme();
    const styling = stylingProp || (colorContext === 'dark' ? 'secondary' : 'primary');
    const getColor = () => {
        if (status === 'error' && styling !== 'secondary') {
            return colors.primary;
        }
        if (status === 'ok' && styling !== 'secondary') {
            return colors['green-100'];
        }
        if (styling === 'secondary') {
            return colors.white;
        }
        return colors['anthracite-100'];
    };
    return (React.createElement(Paragraph, { size: 4, weight: 500 },
        React.createElement("span", { id: id, "data-testid": dataTestId, style: {
                userSelect: 'none',
                color: getColor(),
            } }, (message === null || message === void 0 ? void 0 : message.text) || ZERO_WIDTH_SPACE)));
};
